import { render } from "./ForgetPassword.vue?vue&type=template&id=42b4da79&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import "./ForgetPassword.vue?vue&type=style&index=0&id=42b4da79&scoped=true&lang=css"

import exportComponent from "C:\\ExactFloMarketingTool\\exactfloMarketingTool\\frontend\\marketingtool\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b4da79"]])

export default __exports__